/* @fflow */

import React from 'react';
import moment from 'moment';
import DATE_FORMAT from 'constants/date';
import formatFileSize from '../../../utils/formatFileSize';
import { TBody, Tr, Td } from '../../UIKit/Table';
import Icon from '../../UIKit/Icon/Icon';

import './style.css';

export default function UploadFilesRows({ children, handleOnClick }) {
  return (
    <TBody>
    { children.map((child, i) =>
      <Tr className="submit-tr" key={i}>
        <Td>{child.id}</Td>
        <Td>{formatFileSize(child.size)}</Td>
        <Td>{moment(child.lastModified).format(DATE_FORMAT)}</Td>
        <Td style={{ textAlign: `center` }}>
          <Icon style={{ cursor: `pointer` }} onClick={() => handleOnClick(child.id)}>
            delete
          </Icon>
        </Td>
      </Tr>) }
    </TBody>
  );
}
